module.exports = __webpack_public_path__ + "static/assets/0e60182f6d011d4bc8aafa86c8e0ef28.gif";